<template>
  <footer
    :class="
      'dashboard__footer' + (marginTop ? ' dashboard__footer--margin-top' : '')
    "
  >
    <div class="octopus">
      <img src="@/assets/images/sovalis-poulpy.png" alt="Poulpe" />
    </div>

    <a href="https://sovalis.kerialis.fr/">
      <img
        class="dashboard__footer__logo"
        src="@/assets/images/sovalis-logo-rouge.png"
        alt="Logo Sovalis"
      />
    </a>

    <div class="dashboard__footer__content">
      <p class="dashboard__footer__slogan">
        La plateforme qui vous aide à booster votre visibilité et développer votre
        activité.
      </p>

      <p class="dashboard__footer__text">
        Copyright {{ currentYear }} © SOVALIS -
        <a href="https://sovalis.kerialis.fr/mentions-legales/">Mentions légales</a>
        -
        <a href="https://sovalis.kerialis.fr/politique-des-cookies/"
          >Politique des cookies</a
        >
        -
        <a href="https://sovalis.kerialis.fr/contact/">Contact</a>
        -
        <a href="https://kerialis.fr/protection-des-donnees-a-caractere-personnel"
          >Protection des données</a
        >
        -
        <a href="https://sovalis.kerialis.fr/#form-menu-1346"
          >Proposer mes services</a
        >
      </p>
    </div>

    <div class="dashboard__footer__socials">
      <a
        class="dashboard__footer__socials--linkedin"
        data-timeout="100"
        href="https://www.linkedin.com/company/74689428"
        rel="nofollow noopener"
        target="_blank"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            d="M116.504,500.219V170.654H6.975v329.564H116.504
            L116.504,500.219z M61.751,125.674c38.183,0,61.968-25.328,61.968-56.953c-0.722-32.328-23.785-56.941-61.252-56.941
            C24.994,11.781,0.5,36.394,0.5,68.722c0,31.625,23.772,56.953,60.53,56.953H61.751L61.751,125.674z M177.124,500.219
            c0,0,1.437-298.643,0-329.564H286.67v47.794h-0.727c14.404-22.49,40.354-55.533,99.44-55.533
            c72.085,0,126.116,47.103,126.116,148.333v188.971H401.971V323.912c0-44.301-15.848-74.531-55.497-74.531
            c-30.254,0-48.284,20.38-56.202,40.08c-2.897,7.012-3.602,16.861-3.602,26.711v184.047H177.124L177.124,500.219z"
          ></path>
        </svg>
      </a>

      <a
        class="dashboard__footer__socials--youtube"
        data-timeout="200"
        href="https://www.youtube.com/channel/UCcuuvA1aHSgPfswHt53aZig/featured"
        rel="nofollow noopener"
        target="_blank"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-271 311.2 256 179.8">
          <path
            d="M-59.1,311.2h-167.8c0,0-44.1,0-44.1,44.1v91.5c0,0,0,44.1,44.1,44.1h167.8c0,0,44.1,0,44.1-44.1v-91.5
          C-15,355.3-15,311.2-59.1,311.2z M-177.1,450.3v-98.5l83.8,49.3L-177.1,450.3z"
          />
        </svg>
      </a>

      <a
        class="dashboard__footer__socials--x"
        data-timeout="300"
        href="https://x.com/mercisolency"
        rel="nofollow noopener"
        target="_blank"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
          ></path>
        </svg>
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',

  props: {
    marginTop: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentYear: new Date().getFullYear(),
      apiURL: process.env.VUE_APP_API_URL,
    };
  },
};
</script>
